import React, { Component, PropTypes } from 'react';
import '../styles/introduction.scss';
import '../styles/parallax.scss';

export default class Introduction extends Component {
  render() {
    const { personalInfo } = this.props;
    return (
      <div className="introduction">
        <div className="introduction__content">
          <h2 className="introduction__name">
            SIMON CHAN
          </h2>
          <div className="introduction__tagline">
            Full Stack Software Developer
          </div>
          <div className="introduction__location">
            Brooklyn, New York
          </div>
          <div className="introduction__icons">
            <a href={personalInfo.email} className="nav-link">
              <i className="fa fa-envelope icon"></i>
            </a>
            <a href={personalInfo.github}><i className="fa fa-github icon"></i></a>
            <a href={personalInfo.linkedIn}><i className="fa fa-linkedin-square icon"></i></a>
          </div>
          <a href={personalInfo.resume} className="nav-link" target="_blank" style={{ lineHeight: 'normal', color: 'white' }}>
          <span>Resume</span>
        </a>
        </div>
      </div>
    );
  }
}

Introduction.propTypes = {
  personalInfo: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Introduction.js